<template>
  <div class="product-page--create pa-4 pb-16">
    <v-row no-gutters>
      <v-col cols="12" v-if="!loading">
        <redirect class="mb-5" title="Products" route="website.products" />
        <div class="page-header">
          <h2 class="page-title">{{ name }}</h2>
        </div>
        <div
          style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; flex-direction: row;"
        >
          <div class="d-flex align-center mb-4" style="gap: 6px">
            <!-- <button v-if="!loading" class="mr-3 pointer" @click="submitDuplicate">
            <i class="far fa-copy"></i> Duplicate
          </button> -->
            <div v-if="user && user.email && user.email.includes('abcabc@dropnoxe.com')">
              <button v-if="attributes.published == false" class="mr-3 pointer" @click="attributes.published = true">
                <i class="far fa-eye"></i>
                Show Product
              </button>
              <button v-else class="mr-3 pointer" @click="attributes.published = false">
                <i class="far fa-eye-slash"></i>
                Hide Product
              </button>
            </div>
            <button v-if="attributes.published == true" @click="gotoStore" class="pointer mr-3">
              <i class="show-password far fa-eye fz-16"></i>
              View
            </button>
            <button v-if="attributes.published == true" @click="copyStoreLink" class="pointer mr-3">
              <i class="show-password far fa-copy fz-16"></i>
              Copy link
            </button>

            <button
              v-if="attributes.published == true && attributes.offers && attributes.offers.length > 0"
              @click="gotoOfferDiscount"
              class="pointer mr-3"
            >
              <i class="fas fa-percent fz-16"></i>
              View Offer Discount
            </button>
            <button v-if="nameThems === 'book'" @click="gotoBooks" class="pointer mr-3">
              <i class="show-password fas fa-book fz-16"></i>
              Books
            </button>
          </div>
          <div>
            <v-btn class="text-capitalize" outlined @click="showImportDialog = true">
              <v-icon size="20px">mdi-import</v-icon>
              Import from other source
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- <GroupSubmit mode="edit" :isLoading="isLoading" :callbackCancel="onCancel" :callbackSubmit="onSubmit" /> -->
    <v-row v-if="!loading">
      <v-col class="d-none d-md-block" style="position: relative;" cols="2">
        <div class="menu-sticky elevation-form pa-4 mb-4">
          <ul>
            <li v-for="item in sideMenu" :key="item.id" @click="scrollToSection(item.id)">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </v-col>
      <v-col cols="12" md="7">
        <div class="elevation-form pa-4 mb-4">
          <InputDefault
            :min="0"
            :max="255"
            :model="['attributes', 'title']"
            fieldName="Title"
            label="Title"
            :isValidate="true"
            class="pa-0 mb-2"
            id="title-edit-product"
          />
          <ContentInput
            v-if="!isDropship"
            id="description-edit-product"
            :model="'bodyHtml'"
            title="Description"
            subtitle="Maximum 100.000 characters"
          >
            <v-btn :loading="isLoading" color="primary" class="font-weight-bold" text small @click="onSyncImages"
              >Sync images</v-btn
            >
          </ContentInput>
          <div v-else id="description-edit-product" ref="descriptionContainer">
            <div class="d-flex justify-end mb-3">
              <v-btn outlined @click="handleShowFullPreview" style="height: 32px !important">
                <v-icon left small>mdi-eye</v-icon>
                Preview Section
              </v-btn>
            </div>
            <v-expansion-panels class="mb-3">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-0">
                  <h4 style="cursor: pointer; margin-left: 16px; font-weight: 500;">Hurry box</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-4">
                  <div v-if="hasUpdateSection" ref="hurryBoxSection">
                    <HurryBox
                      :model="'shortDescription'"
                      :catalog="attributes"
                      :sectionsPanel="hurryBoxSectionsPanel"
                      @update:sectionsPanel="onUpdateHurryBoxSectionsPanel"
                      @update:bodyHtmlHurryBox="onUpdateBodyHtmlHurryBox"
                    />
                  </div>
                  <div v-else class="description-readonly" v-html="attributes.shortDescription"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels class="mb-3">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-0">
                  <h4 style="cursor: pointer; margin-left: 16px; font-weight: 500;">Order Policy</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-4">
                  <div v-if="hasUpdateSection" ref="orderPolicySection">
                    <OrderPolicy
                      :model="'orderPolicy'"
                      :catalog="attributes"
                      :sectionsPanel="orderPolicySectionsPanel"
                      @update:sectionsPanel="onUpdateOrderPolicySectionsPanel"
                      @update:bodyHtmlOrderPolicy="onUpdateBodyHtmlOrderPolicy"
                    />
                  </div>
                  <div v-else class="description-readonly" v-html="attributes.orderPolicy"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels class="mb-3">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-0">
                  <h4 style="cursor: pointer; margin-left: 16px; font-weight: 500;">Other Desciption</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-4">
                  <div v-if="hasUpdateSection" ref="orderDescriptionSection">
                    <Description
                      :model="'orderDescription'"
                      :catalog="attributes"
                      :sectionsPanel="orderDescriptionSectionsPanel"
                      @update:sectionsPanel="onUpdateOrderDescriptionSectionsPanel"
                      @update:bodyHtmlDescription="onUpdateBodyHtmlOrderDescription"
                    />
                  </div>
                  <div v-else class="description-readonly" v-html="attributes.orderDescription"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels class="mb-3">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-0">
                  <h4 style="cursor: pointer; margin-left: 16px; font-weight: 500;">Desciption</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-4">
                  <div v-if="hasUpdateSection" ref="descriptionSection">
                    <Description
                      :model="'bodyHtml'"
                      :catalog="attributes"
                      :sectionsPanel="descriptionSectionsPanel"
                      @update:sectionsPanel="onUpdateSectionsPanel"
                      @update:bodyHtmlDescription="onUpdateBodyHtmlDescription"
                    />
                  </div>
                  <div v-else class="description-readonly" v-html="attributes.bodyHtml"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <Images id="images-edit-product" class="mb-4" />
        <div v-if="attributes.latePrintRef" class="elevation-form mb-4 pa-3">
          <div class="form-component">
            <div class="d-flex justify-space-between align-center">
              <label for=""> Update Shipping </label>
            </div>
            <div>
              <v-col cols="12">
                <table id="table-ali" style="width: 100%; max-height: 500px; overflow-y: auto">
                  <tr>
                    <th style="text-align: center;">Ship to :</th>
                    <th style="    cursor: pointer;width:120px;text-align: center;">
                      <select
                        style="border: 1px solid #ddd !important; padding: 8px;cursor: pointer;"
                        @change="changeShipCode(attributes.shipCode, attributes, k)"
                        v-model="attributes.shipCode"
                      >
                        <option style="cursor: pointer;" value="US"><h4>United States</h4></option>
                        <option style="cursor: pointer;" value="ROW"><h4>Rest Of Wolrd</h4></option>
                      </select>
                    </th>
                    <th style="text-align: center;">
                      <!-- Shipping method : -->
                      <select
                        style="border: 1px solid #ddd !important; padding: 8px;cursor: pointer;"
                        v-model="attributes.shipMethods"
                      >
                        <option style="cursor: pointer;" value="standard"><h4>Standard Shipping</h4></option>
                        <option style="cursor: pointer;" value="express"><h4>Express</h4></option>
                      </select>
                    </th>
                    <th style="cursor: pointer;width:150px;text-align: center;"></th>
                    <th></th>
                    <th style="width: 120px;"></th>
                  </tr>
                  <tr class="pt-3">
                    <th>Variants</th>
                    <!-- <th>Country</th>
              <th>Contact</th> -->
                    <th>
                      Shipping
                      <div class="change-all-il relative-il">
                        Change All
                        <v-icon @click="changeAll('shipping', attributes, k)">mdi-chevron-double-down</v-icon>
                        <div v-if="attributes.dialog.shipping" class="change-all-dialog">
                          <v-card class=" pa-3">
                            <h3>New price</h3>
                            <div>
                              <div>
                                <span> New price 1st</span>

                                <v-text-field v-model.number="all.priceF" type="number" :min="0"></v-text-field>
                              </div>
                              New price 2nd

                              <v-text-field v-model.number="all.priceS" type="number" :min="0"></v-text-field>
                            </div>
                            <div style="display: flex;justify-content: end;">
                              <v-btn @click="submitChangeAllShipping('shipping', attributes, k)" color="primary"
                                >Apply</v-btn
                              >
                            </div>
                          </v-card>
                        </div>
                      </div>
                    </th>
                    <th style="width: 200px;">
                      Selling Price
                    </th>

                    <th>Profit</th>
                  </tr>
                  <tbody>
                    <tr class="check-input pt-4" v-for="v in attributes.variants" :key="`a${v._id}`">
                      <td style="min-width:120px" class="text-center">{{ v.option1 }} / {{ v.option2 }}</td>
                      <td style="display: flex;" class="text-center">
                        <v-text-field
                          style="width:150px"
                          prefix="$"
                          suffix="1st"
                          type="number"
                          hide-details
                          v-model.number="v.shippingCode[attributes.shipCode].shipfirstItem"
                        ></v-text-field>
                        <v-text-field
                          style="width:140px;padding:0px"
                          prefix="$"
                          suffix="2nd"
                          type="number"
                          hide-details
                          v-model.number="v.shippingCode[attributes.shipCode].shipAdditionalItem"
                        ></v-text-field>
                      </td>
                      <td class="text-center">
                        {{ v[`price`] }}
                      </td>
                      <!-- //- v.cost -->
                      <td style="width:120px;color:#0bcf21" class="text-center">
                        {{ calculateProfit(v) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </div>
            <div></div>
          </div>
        </div>
        <!-- <Pricing v-if="isVariantDefault" class="mb-4" /> -->
        <Inventory v-if="isVariantDefault" class="mb-4" />
        <Shipping v-if="isVariantDefault" class="mb-4" />
        <div v-if="!isDropship" class="elevation-form pa-4 mt-4">
          <div class="form-component">
            <label for=""> Personalization </label>
            <div class="my-2">
              <!-- <v-btn @click="addOption"> Create custom option only </v-btn> -->
              <v-btn class="mx-3" @click="gotoPreviewImage" v-if="!hasCustom"> Create Custom Product </v-btn>
              <v-btn
                v-if="hasCustom"
                class="ml-2"
                @click="$router.push({ name: 'website.product-personalized.update', params: { id: personalizedId } })"
                color="primary"
                >Update</v-btn
              >
            </div>
          </div>
          <div style="width: 100%">
            <div class="personalize-production"></div>
          </div>
          <!-- <div style="width: 100%" class="custom-option">
            <div v-for="(item, index) in customOptions" :key="index" class="mt-6">
              <label class="d-block font-weight-bold mb-2">Custom Options {{ index != 0 ? index : '' }}</label>
              <div>
                <v-row class="my-0">
                  <v-col class="py-0" sm="12"><h4>Name</h4></v-col>
                  <v-col class="py-0" sm="12">
                    <v-text-field v-model="item.name" hide-details=""></v-text-field>
                  </v-col>
                  <v-col
                    v-if="item.name == ''"
                    sm="12"
                    class="pb-0 pt-2"
                    style="line-height: 12px; word-break: break-word; color: red; font-size: 12px"
                    >Please finish this field</v-col
                  >
                  <v-col class="py-0 mt-5" sm="12"><h4>Label (display on storefront)</h4></v-col>
                  <v-col class="py-0" sm="12" style="height: 215px">
                    <quill-editor
                      class="disciplineQE"
                      v-model="item.bodyHtml"
                      :options="{
                        theme: 'snow',
                      }"
                    />
                  </v-col>
                  <v-col
                    v-if="item.bodyHtml == ''"
                    sm="12"
                    class="pb-0 pt-2"
                    style="line-height: 12px; word-break: break-word; color: red; font-size: 12px"
                    >Please finish this field</v-col
                  >
                  <v-col sm="6"><h4>Type</h4></v-col>
                  <v-col sm="6"><h4>Required?</h4></v-col>
                  <v-col class="py-0" sm="6"
                    ><v-select
                      v-model="item.type"
                      :items="[
                        {
                          title: 'Text field',
                          value: 'textField',
                        },
                        {
                          title: 'Text area',
                          value: 'textArea',
                        },
                        {
                          title: 'Image',
                          value: 'image',
                        },
                        {
                          title: 'Radio buttons',
                          value: 'radioButtons',
                        },
                        {
                          title: 'Droplist',
                          value: 'droplist',
                        },
                        {
                          title: 'Checkbox',
                          value: 'checkbox',
                        },
                        {
                          title: 'Picture choice',
                          value: 'pictureChoice',
                        },
                      ]"
                      item-value="value"
                      item-text="title"
                    ></v-select
                  ></v-col>
                  <v-col class="py-0" sm="6">
                    <v-radio-group class="mt-0" v-model="item.validations.required" row>
                      <v-radio label="No" :value="false"></v-radio>
                      <v-radio label="Yes" :value="true"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col class="py-0" sm="6"><h4>Placeholder (optional)</h4></v-col>
                  <v-col class="py-0" sm="6"><h4>Max length</h4></v-col>
                  <v-col class="py-0" sm="6"
                    ><v-text-field v-model="item.placeholder" hide-details=""></v-text-field
                  ></v-col>
                  <v-col class="py-0" sm="6">
                    <v-text-field
                      type="number"
                      v-model.number="item.validations.max_length"
                      hide-details=""
                    ></v-text-field>
                  </v-col>
                  <v-col class="pb-0 pt-2" v-if="item.validations.max_length == ''" sm="6"></v-col>
                  <v-col
                    v-if="item.validations.max_length == ''"
                    sm="6"
                    class="pb-0 pt-2"
                    style="line-height: 12px; word-break: break-word; color: red; font-size: 12px"
                    >Please finish this field</v-col
                  >
                  <v-col class="py-0 my-2" sm="6"><h4>Default value (prefill on storefront)</h4></v-col>
                  <v-col class="py-0" sm="12"><v-text-field v-model="item.default_value"></v-text-field></v-col>
                  <v-col class="py-0" sm="6"><h4>Allow the following characters</h4></v-col>
                  <v-col class="py-0" sm="12">
                    <v-row>
                      <v-col sm="3">
                        <v-checkbox
                          v-model="item.validations.allowed_characters"
                          label="Characters"
                          value="characters"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col sm="3">
                        <v-checkbox
                          v-model="item.validations.allowed_characters"
                          label="Numbers"
                          value="numbers"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col sm="4">
                        <v-checkbox
                          v-model="item.validations.allowed_characters"
                          label="Special Characters"
                          value="special_characters"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col sm="2">
                        <v-checkbox
                          v-model="item.validations.allowed_characters"
                          label="Emoji"
                          value="emoji"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-if="item.validations.allowed_characters == ''"
                    sm="6"
                    class="pb-0 pt-2"
                    style="line-height: 12px; word-break: break-word; color: red; font-size: 12px"
                    >You have to select at least one option.</v-col
                  >

                  <v-col cols="12" class="d-flex justify-space-between">
                    <v-btn color="error" icon @click="removeCustomOption(index)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      color="primary"
                      v-if="customOptions.length > 0 && index == customOptions.length - 1"
                      @click="addOption()"
                      >Add option</v-btn
                    >
                  </v-col>
                  <v-col
                    v-if="customOptions.length > 0 && customOptions.length > 0 && index < customOptions.length - 1"
                    cols="12"
                  >
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div> -->
        </div>
        <!-- Pack Pricing Information -->
        <div
          v-if="attributes.catalog && attributes.catalog.packs && attributes.catalog.packs.length > 0"
          class="mb-4 elevation-form pa-3"
        >
          <div class="d-flex justify-space-between align-center mb-3">
            <h3>Pack detail</h3>
          </div>
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="text-align: left; padding: 12px; border-bottom: 1px solid #ddd;">Pack name</th>
                <th style="text-align: right; padding: 12px; border-bottom: 1px solid #ddd;">Base cost</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(pack, index) in attributes.catalog.packs"
                :key="`pack-${pack._id || index}`"
                style="border-bottom: 1px solid #eee;"
              >
                <td style="padding: 12px;">{{ pack.title }}</td>
                <td style="text-align: right; padding: 12px;">$ {{ (pack.baseCost || 0).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <Variants id="variants-edit-product" v-if="isVariantDefault" class="mb-4" />
        <!-- {{ isVariantDefault }} -->
        <VariantsEdit id="variants-edit-product" v-else class="mb-4" />

        <div id="search-engine-listing-preview-edit-product">
          <v-col cols="12" sm="12" xs="12" class="px-3 elevation-form py-0">
            <template>
              <v-row justify="center">
                <v-expansion-panels v-model="isOpen" accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate>
                      <div>
                        <h3>Search engine listing preview</h3>
                        <p class="mt-5">
                          Add a title and description to see how this collection might appear in a search engine listing
                        </p>
                      </div>
                      <template v-slot:actions>
                        <span class="btn-link">Edit website SEO</span>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <template>
                        <v-checkbox
                          label="Large Link Preview"
                          v-model="attributes.typeLargeShowLinkReview"
                          class="mt-0"
                        ></v-checkbox>
                        <div
                          class="link-preview"
                          :class="{
                            'link-preview--large': attributes.typeLargeShowLinkReview,
                            'link-preview--compact': !attributes.typeLargeShowLinkReview,
                          }"
                        >
                          <div class="link-preview__url primary--text">
                            {{ storeURL + '/products/' + attributes.metafieldsGlobalUrl }}
                          </div>

                          <div
                            v-if="
                              attributes.metafieldsGlobalTitleTag ||
                                attributes.metafieldsGlobalDescriptionTag ||
                                attributes.metafieldsGlobalLinkImg
                            "
                            class="link-preview__body"
                          >
                            <div class="link-preview__content">
                              <div v-if="attributes.metafieldsGlobalTitleTag" class="link-preview__title primary--text">
                                {{ attributes.metafieldsGlobalTitleTag }}
                              </div>

                              <div v-if="attributes.metafieldsGlobalDescriptionTag" class="link-preview__description">
                                {{ attributes.metafieldsGlobalDescriptionTag }}
                              </div>
                            </div>

                            <img
                              v-if="attributes.metafieldsGlobalLinkImg"
                              :src="
                                imageHelpers.url(attributes.metafieldsGlobalLinkImg, {
                                  width: attributes.typeLargeShowLinkReview ? 800 : 100,
                                  height: attributes.typeLargeShowLinkReview ? 500 : 100,
                                })
                              "
                              class="link-preview__image"
                            />
                          </div>
                        </div>
                        <div class="mt-3">
                          <label for="">Meta title</label>
                          <v-text-field
                            v-model="attributes.metafieldsGlobalTitleTag"
                            class=""
                            counter="70"
                            maxLength="70"
                            label=""
                          ></v-text-field>
                        </div>

                        <div class="mt-3">
                          <label for="">Meta description</label>
                          <v-textarea
                            v-model="attributes.metafieldsGlobalDescriptionTag"
                            class=""
                            counter="320"
                            maxLength="320"
                            label=""
                          ></v-textarea>
                        </div>

                        <div class="mt-3">
                          <label for="">Meta image</label>
                          <UploadOneImage
                            :image="{ src: attributes.metafieldsGlobalLinkImg }"
                            @callback="getImageUpLoad"
                          />
                        </div>

                        <div class="mt-3">
                          <label>URL and handle</label>
                          <div style="position: relative;">
                            <v-text-field
                              v-model="attributes.metafieldsGlobalUrl"
                              :prefix="storeURL + '/products/'"
                              hide-details="auto"
                              outlined
                              dense
                              style="position: relative; z-index: 1;"
                            ></v-text-field>
                            <v-btn
                              style="position: absolute; top: 2px; right: 0; z-index: 10;"
                              icon
                              @click="copyLink(attributes.metafieldsGlobalUrl)"
                            >
                              <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                          </div>
                          <v-checkbox
                            v-model="attributes.metafieldsGlobalUrlRedirect"
                            :label="
                              `Create a URL redirect from ${attributes.handle} -> ${attributes.metafieldsGlobalUrl}`
                            "
                          ></v-checkbox>
                        </div>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </template>
          </v-col>
        </div>

        <SharePromptList v-if="idItem" id="share-prompt-list-edit-product" :productId="idItem" class="mb-4" />
      </v-col>
      <v-col cols="12" md="3" class="d-flex flex-column">
        <!-- <div class="elevation-form pa-3">
          <ProductAvailability />
        </div> -->
        <Organization :collections="selectedCollections" :collectionAuto="selectedCollectionsAuto" class="mb-4" />
        <div class="mb-4">
          <Pixel id="pixels-edit-product" :pixelData.sync="attributes.pixels" :onChange="onPixelChanged" />
        </div>
        <!-- <SizeChart v-model="attributes.sizeChart" class="mb-4" /> -->
        <div class="mb-4">
          <div class="size-chart-component pa-3" style="border: 1px solid #eee; border-radius: 8px;">
            <div class="d-flex align-center mb-2">
              <label>Size chart</label>
            </div>
            <div class="" style="position:relative; min-height: 120px;">
              <template v-if="attributes.sizeChart">
                <v-img
                  :src="imageHelpers.url(attributes.sizeChart, { width: 500, height: 500 })"
                  contain
                  class="rounded-preview"
                />
              </template>
              <template v-else>
                <div class="text-center text--secondary no-preview" style="padding: 24px 0;">No size chart image</div>
              </template>
            </div>
          </div>
        </div>
        <!-- <ReviewCard id="reviews-edit-product" :productId="idItem" class="mb-4" /> -->
        <template v-for="(option, index) in getOptionTemplates">
          <div
            class="elevation-form pa-3 mb-4"
            v-if="option.type == 'options' && Array.isArray(option.values)"
            :key="index"
          >
            <Options
              :name="option.name"
              :values="option.values"
              :onSelectedOptions="onSelectedOptions"
              :removeOption="removeOption"
            />
          </div>
        </template>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <div class="action-buttons-sticky">
      <v-spacer></v-spacer>
      <v-btn outlined class="mr-3" @click="onCancel">Discard</v-btn>
      <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="onSubmit">Save</v-btn>
    </div>
    <div style="width: 100%; height: 100%" v-if="loading" class="d-flex justify-center align-center">
      <page-loader />
    </div>
    <delete-action :content="'product ' + name" :title="'Delete ' + name" />
    <BeforeLeavePage />
    <v-dialog v-model="fullPreview.open" fullscreen style="z-index: 100001">
      <SectionPreview
        :open="fullPreview.open"
        :descriptionHtml="fullPreview.descriptionHtml"
        :orderPolicyHtml="fullPreview.orderPolicyHtml"
        :hurryBoxHtml="fullPreview.hurryBoxHtml"
        :title="fullPreview.title"
        :image="fullPreview.image"
        @close="handleCloseFullPreview"
      />
    </v-dialog>
    <v-dialog v-model="showImportDialog" fullscreen hide-overlay scrollable persistent>
      <ImportFromSource @close="showImportDialog = false" @imported="onImported" />
    </v-dialog>
  </div>
</template>

<script>
import { productApi } from '@/apis/product';
import { shortlinkApi } from '@/apis/shortlink';
import utilities from '@/helpers/utilities';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import ContentInput from '@/views/website/components/Editor';
import Images from '@/views/website/products/components/Images';
// import ProductAvailability from '@/views/website/products/components/ProductAvailability';
import imageHelpers from '@/helpers/image';
import Inventory from '@/views/website/products/components/Inventory';
import Organization from '@/views/website/products/components/Organization';
// import Pricing from '@/views/website/products/components/Pricing';
import Shipping from '@/views/website/products/components/Shipping';
import Variants from '@/views/website/products/components/Variants';
import Options from './components/Options.vue';
import Pixel from './components/Pixel.vue';
// import ReviewCard from './components/ReviewCard';
import VariantsEdit from './components/VariantEdit';
import SharePromptList from './components/SharePromptList.vue';
// import SizeChart from '@/views/website/products/components/SizeChart';
// import STORAGE_NAME from '@/const/storage';
import { FETCH_PRODUCT_OPTION_TEMPLATES, FETCH_STORES } from '@/store/actions.type';
import { mapGetters, mapState } from 'vuex';
// import { log } from 'handlebars';
import { paymentService } from '@/apis/payment';
import { personalizesApi } from '@/apis/personalizes';
import { uploadService } from '../../../apis/upload.s';
import './components/description/styles/swiper.css';
import './components/description/styles/section-style.scss';
import './components/description/styles/section-style-backup.scss';
import './components/description/styles/section-small.scss';
import './components/description/styles/description-style.scss';
import catalogEffect from '@/mixins/catalogEffect';
import SectionPreview from './components/description/modal-sections/section-preview.vue';
import Description from './components/description/index.vue';
import HurryBox from './components/description/hurry-box.vue';
import OrderPolicy from './components/description/order-policy.vue';
import ImportFromSource from './components/import-from-source.vue';
import { processFinalCatalogHtml } from './components/description/common/utils';
import { authService } from '@/apis/permission';

export default {
  // mixins: [resourceBeforeLeavePage],
  components: {
    ContentInput,
    Images,
    // ProductAvailability,
    Organization,
    // SizeChart,
    // Pricing,
    Inventory,
    Shipping,
    Variants,
    VariantsEdit,
    Options,
    // ReviewCard,
    Pixel,
    SharePromptList,
    Description,
    HurryBox,
    OrderPolicy,
    SectionPreview,
    ImportFromSource,
  },
  mixins: [catalogEffect],
  data() {
    let defaultForm = {
      title: '',
      bodyHtml: '',
      shortDescription: '',
      orderDescription: '',
      orderPolicy: '',
      published: true,
      tags: [],
      vendor: '',
      gtin: '',
      images: [],
      productType: '',
      group: null,
      collections: '',
      // collections: [
      //   {
      //     _id: '6002b02bdddb2b3bbc85f42d',
      //   },
      // ],
      deleteImageIds: [], // chua biet giao dien the nao
      variants: [
        {
          active: true,
          title: '', //option1/option2/option3
          option1: '',
          option2: '',
          option3: '',
          imageId: '',
          barCode: '',
          gtin: '',
          compareAtPrice: '',
          inventoryManagement: '', // [no, hiweb]Nhập, mặc định là no, nếu no không cập nhật quantity, nếu  hiweb thì cập nhật sau khi có order
          costPerItem: null, // cost item
          inventoryPolicy: '', //continue, deny
          inventoryQuantity: null, // Số sản phẩm trong store, 0 = Soldout
          requiresShipping: true,
          weight: 0,
          weightUnit: 'lb',
          taxable: true,
          isDefault: true,
          price: null,
          sku: '',
          fulfillmentService: '',
          baseCost: null,
        },
      ],
      pixels: [],
      sizeChart: '',
      metafieldsGlobalLinkImg: '',
      typeLargeShowLinkReview: true,
    };
    let variantDefaultForm = {
      // se an theo 1 trong 2 thang, uu tien variants
      title: 'Default Title',
      active: true,
      barCode: '',
      gtin: '',
      compareAtPrice: '',
      inventoryManagement: '', // [no, hiweb]Nhập, mặc định là no, nếu no không cập nhật quantity, nếu  hiweb thì cập nhật sau khi có order
      costPerItem: null, // cost item
      inventoryPolicy: '', //continue, deny
      inventoryQuantity: null, // Số sản phẩm trong store, 0 = Soldout
      requiresShipping: true,
      weight: 0,
      weightUnit: 'lb',
      taxable: true,
      isDefault: true,
      price: null,
      sku: '',
      fulfillmentService: '',
      baseCost: null,
    };
    return {
      showImportDialog: false,
      isOpen: null,
      item: {},
      selectedCollections: [],
      selectedCollectionsAuto: [],
      imagesSelect: [],
      isVariantDefault: false,
      showDialogDelete: false,
      name: '',
      idItem: null,
      isLoading: false,
      loading: false,
      page: {},
      showHeader: false,
      searchString: 'null hihi',
      attributes: Object.assign({}, defaultForm),
      variantDefault: Object.assign({}, variantDefaultForm),
      defaultForm,
      variantDefaultForm,
      listVariants: [],
      // Product options
      all: {
        priceF: 0,
        priceS: 0,
      },
      options: [], // need
      imageHelpers,
      imageKeyList: {},
      detailOptions: [],
      nameThems: '',
      customOptions: [],
      paymentMethods: [],
      payment: { processingFee: 0, paymentFee: 0 },
      shipCode: 'US',
      // editor: Editor,
      // editorConfig: ckeditorConfig,
      hasCustom: false,
      personalizedId: null,
      sideMenu: [
        {
          title: 'Title',
          id: 'title-edit-product',
        },
        {
          title: 'Description',
          id: 'description-edit-product',
        },
        {
          title: 'Images',
          id: 'images-edit-product',
        },
        // {
        //   title: 'Personalization',
        //   id: 'personalization-edit-product',
        // },
        {
          title: 'Variants',
          id: 'variants-edit-product',
        },
        {
          title: 'Reviews',
          id: 'reviews-edit-product',
        },
        {
          title: 'Pixels',
          id: 'pixels-edit-product',
        },
        {
          title: 'Edit website SEO',
          id: 'search-engine-listing-preview-edit-product',
        },
        {
          title: 'Share prompt list',
          id: 'share-prompt-list-edit-product',
        },
        // {
        //   title: 'Organization',
        //   id: 'organization-edit-product',
        // },
        // {
        //   title: 'Product type',
        //   id: 'product-type-edit-product',
        // },
        // {
        //   title: 'Niche',
        //   id: 'niche-edit-product',
        // },
        // {
        //   title: 'Vendor',
        //   id: 'vendor-edit-product',
        // },
        // {
        //   title: 'GTIN',
        //   id: 'gtin-edit-product',
        // },
        // {
        //   title: 'Collections',
        //   id: 'collections-edit-product',
        // },
        // {
        //   title: 'Tags',
        //   id: 'tags-edit-product',
        // },
        // {
        //   title: 'Catalog code',
        //   id: 'catalog-code-edit-product',
        // },
      ],
      fullPreview: {
        open: false,
        descriptionHtml: '',
        orderPolicyHtml: '',
        hurryBoxHtml: '',
        title: '',
        image: '',
      },
      accountOwner: null,
    };
  },
  mounted() {
    this.nameThems = localStorage.getItem(`nameTheme`);
  },
  async created() {
    this.loading = true;
    const isDataLoaded = await this.getData();
    if (!isDataLoaded) {
      this.loading = false;
      return;
    }
    await this.$store.dispatch(FETCH_PRODUCT_OPTION_TEMPLATES);
    await this.$store.dispatch(FETCH_STORES);
    await this.loadPayments();
    this.loading = false;
    await this.getPersonalize();
    this.$nextTick(() => this.runDescriptionEnhancements());
    this.getStoreStaffs();
  },
  methods: {
    getImageUpLoad(image) {
      this.attributes.metafieldsGlobalLinkImg = image.src;
    },
    normalizeImgSrc(src) {
      if (!src || typeof src !== 'string') {
        return '';
      }
      let trimmedSrc = src.trim().replace('{width}', '1024');
      if (trimmedSrc.startsWith('//')) {
        return `https:${trimmedSrc}`;
      }
      return trimmedSrc;
    },
    onImported({ data, sections }) {
      if (!data) return;
      const rawHtml = sections.map(s => s.html).join('');
      const next = { ...this.attributes };
      const assignIfPresent = (key, value) => {
        if (value !== undefined && value !== null) next[key] = value;
      };
      assignIfPresent('bodyHtml', processFinalCatalogHtml(rawHtml));

      if (Array.isArray(data.images)) {
        next.images = data.images
          .map((item, index) => {
            if (!item) return null;
            if (typeof item === 'string') return { src: item, index };
            if (item.src)
              return {
                src: this.normalizeImgSrc(item.src),
                index: typeof item.index === 'number' ? item.index : index,
              };
            return null;
          })
          .filter(Boolean);
      }

      this.attributes = next;
    },
    runDescriptionEnhancements() {
      if (this.loading) return;

      let container = this.$refs.descriptionContainer;
      if (container && container.$el) container = container.$el;

      if (!container) {
        // Waiting for DOM to be ready
        setTimeout(() => this.runDescriptionEnhancements(), 0);
        return;
      }

      if (typeof window.descriptionjs === 'function') {
        try {
          window.descriptionjs();
        } catch (e) {
          console.warn('runProductSection:', e);
        }
      }
    },
    copyLink(product) {
      const rDomain = this.$store.state.auth.accountInfo.rDomain;

      let sid = '';
      try {
        const dropnoxeUser = JSON.parse(localStorage.getItem('dropnoxe-user') || '{}');
        sid = dropnoxeUser?.id || '';
      } catch (e) {
        sid = '';
      }
      const sidQuery = sid ? `?plf_sid=${encodeURIComponent(sid)}` : '';

      let link = '';
      if (rDomain.indexOf('.dropnoxe.com') >= 0) {
        link = `https://${this.$store.state.auth.accountInfo.rDomain}/products/${product}${sidQuery}`;
      } else {
        link = `https://www.${this.$store.state.auth.accountInfo.rDomain}/products/${product}${sidQuery}`;
      }
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.$store.commit('setMessages', {
            messages: 'Link copied to clipboard!',
            type: 'success',
          });
        })
        .catch(err => {
          console.error('Failed to copy link: ', err);
          this.$store.commit('setMessages', {
            messages: 'Failed to copy link.',
            type: 'error',
          });
        });
    },
    scrollToSection(id) {
      const el = document.getElementById(id);
      if (el) {
        const yOffset = -150;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    },
    submitChangeAllShipping(name, i, k) {
      let a = {
        ...i,
        variants: i.variants.map(v => {
          return {
            ...v,
            shippingInfos: v.shippingInfos.map(s => {
              return {
                ...s,
                shipAdditionalItem: this.all.priceS,
                shipfirstItem: this.all.priceF,
              };
            }),
          };
        }),
      };
      this.attributes = {
        ...a,
        variants: a.variants.map(v => {
          return {
            ...v,
            shippingCode: JSON.parse(JSON.stringify(this.converShipping(v.shippingInfos))),
          };
        }),
      };
      i.dialog[name] = false;
      this.$forceUpdate();
    },
    changeAll(name, i, k) {
      this.all = {
        priceF: 0,
        priceS: 0,
      };
      this.dialog = {
        ...this.dialog,
      };
      i.dialog[name] = !i.dialog[name];
      console.log('name', name);
    },
    changeShipCode(code, item) {
      this.shipCode = code;
      this.attributes = {
        ...this.attributes,
        shipCode: code,

        variants: item.variants.map(v => {
          return {
            ...v,
            shippingCode: JSON.parse(JSON.stringify(this.converShipping(v.shippingInfos))),
          };
        }),
      };
      this.$forceUpdate();
    },
    removeCustomOption(index) {
      this.customOptions.splice(index, 1);
    },
    addOption() {
      this.customOptions.push({
        name: '',
        bodyHtml: '',
        type: 'textField',
        placeholder: '',
        default_value: '',
        validations: {
          allowed_characters: ['characters', 'numbers'],
          max_length: 30,
          required: true,
        },
      });
    },
    gotoPreviewImage() {
      this.$router.push({ path: '/admin/product-personalized/create/' + this.idItem });
    },
    // async submitDuplicate() {
    //   try {
    //     this.loading = true;
    //     let data = (await productApi.getById(this.idItem)).data.product;
    //     let res = await productApi.create({ ...data, title: `Copy of ${data.title}` });
    //     this.$router.push({ name: 'website.products.update', params: { id: res.data.product._id } });
    //     await this.getData();
    //   } catch (error) {
    //     //empty
    //   }
    //   this.loading = false;
    // },
    getStoreUrl() {
      const handle = this.attributes?.metafieldsGlobalUrl || this.attributes?.handle;

      let sid = '';
      try {
        const dropnoxeUser = JSON.parse(localStorage.getItem('dropnoxe-user') || '{}');
        sid = dropnoxeUser?.id || '';
      } catch (e) {
        sid = '';
      }
      const sidQuery = sid ? `?plf_sid=${encodeURIComponent(sid)}` : '';

      const isNews = this.attributes?.gemPage && this.attributes?.gemPage.titleButton && this.attributes?.gemPage.title;
      const domainPrefix = this.$store.state.auth?.accountInfo?.rDomain?.includes('.dropnoxe.com') ? '' : 'www.';
      const rDomain = this.$store.state.auth.accountInfo.rDomain;

      return isNews
        ? `https://${domainPrefix}${rDomain}/posts/${handle}-news${sidQuery}`
        : `https://${domainPrefix}${rDomain}/products/${handle}${sidQuery}`;
    },
    gotoStore() {
      window.open(this.getStoreUrl());
    },
    gotoOfferDiscount() {
      this.$router.push({
        name: 'website.apps.quantity.update',
        params: { id: this.attributes?.offers?.[0] },
      });
    },
    copyStoreLink() {
      navigator.clipboard
        .writeText(this.getStoreUrl())
        .then(() => {
          this.$store.commit('setMessages', {
            messages: 'Link copied to clipboard!',
            type: 'success',
          });
        })
        .catch(err => {
          console.error('Failed to copy link: ', err);
          this.$store.commit('setMessages', {
            messages: 'Failed to copy link.',
            type: 'error',
          });
        });
    },
    gotoBooks() {
      window.location.href = `/products/books/${this.$route.params.id}`;
      // this.$router.push(`/products/books/${this.$route.params.id}`);
    },
    converShipping(array) {
      let keyShipping = {};
      array.forEach(i => {
        keyShipping[i.countryCode] = i;
      });
      if (!keyShipping.US) {
        keyShipping.US = {
          countryCode: 'US',
          countryName: 'United State',
          method: 'standard',
          shipAdditionalItem: 0,
          shipfirstItem: 0,
        };
      }
      if (!keyShipping.ROW) {
        keyShipping.ROW = {
          countryCode: 'ROW',
          countryName: 'Rest Of World',
          method: 'standard',
          shipAdditionalItem: 3.59,
          shipfirstItem: 6.49,
        };
      }
      return keyShipping;
    },
    async getData() {
      try {
        this.idItem = this.$route.params.id;
        let res = (await productApi.getById(this.idItem)).data.product;
        let res1 = await productApi.getByIdSmart(this.idItem);
        this.name = res.title;
        this.selectedCollections = res.collections;
        this.selectedCollectionsAuto = res1.data.smartCollections;
        this.attributes = {
          shipMethods: 'standard',
          dialog: {
            shipping: false,
          },
          published: res.published,
          bodyHtml: res.bodyHtml,
          shortDescription: res.shortDescription,
          orderDescription: res.orderDescription,
          orderPolicy: res.orderPolicy,
          title: res.title,
          images: res.images,
          vendor: res.vendor,
          gtin: res.gtin,
          productType: res.productType,
          tags: res.tags,
          rules: res.rules,
          disjunctive: true,
          latePrintRef: res.latePrintRef,
          handle: res.handle,
          googleProductId: res.googleProductId,
          customOptions: res.customOptions,
          niche: res.niche,
          deleteImageIds: res.deleteImageIds ? res.deleteImageIds : [],
          collections: res.collections && res.collections.length > 0 ? res.collections.map(it => it._id) : [],
          metafieldsGlobalDescriptionTag: res?.metafieldsGlobalDescriptionTag || '',
          metafieldsGlobalTitleTag: res?.metafieldsGlobalTitleTag || '',
          metafieldsGlobalUrl: res?.metafieldsGlobalUrl || res.handle,
          metafieldsGlobalUrlRedirect: res?.metafieldsGlobalUrlRedirect || false,
          metafieldsGlobalLinkImg: res?.metafieldsGlobalLinkImg || '',
          typeLargeShowLinkReview: res?.typeLargeShowLinkReview ?? true,
          shipCode: 'US',
          isTM: res.isTM,
          variants: res.variants.map(v => {
            return {
              ...v,
              baseCost: Number(v.baseCost?.toFixed(2)),
              shippingCode: JSON.parse(JSON.stringify(this.converShipping(v.shippingInfos))),
            };
          }),
          pixels: res.pixels,
          sizeChart: res.sizeChart,
          catalog: res.catalog,
          google_product_category_id: res.google_product_category_id,
          offers: res.offers,
        };
        this.variantDefault = res.variantDefault;
        this.variantDefault.baseCost = Number((res?.variantDefault?.baseCost || 0).toFixed(2)) || 0;
        this.options = res.options;
        this.imagesSelect = [];
        this.imageKeyList = {};
        this.isOpen = res?.metafieldsGlobalUrl ? 0 : null; //nếu metafieldsGlobalUrl có thì mặc định mở SEO không thì đóng
        for (let index = 0; index < res.images.length; index++) {
          this.imagesSelect.push({
            ...res.images[index],
            src: this.imageHelpers.url(res.images[index].src),
            id: res.images[index]._id,
            srcRelative: res.images[index].src,
          });
          this.imageKeyList[res.images[index]._id] = res.images[index];
        }
        // this.imagesSelect = res.images.map(item => {
        //   return {
        //     ...item,
        //     src: this.imageHelpers.url(item.src),
        //     id: item._id,
        //   };
        // });
        this.customOptions = res.customOptions || [];
        this.customOptions.map(item => {
          if (!item.validations) {
            item['validations'] = {
              allowed_characters: ['characters', 'numbers'],
              max_length: 30,
              required: true,
            };
          }
          return item;
        });
        this.$forceUpdate();
        let variantDefaultItem = res.variants.find(item => item.isDefault === true);
        if (variantDefaultItem) {
          this.isVariantDefault = true;
        } else {
          this.isVariantDefault = false;
          this.listVariants = res.variants;
        }
        if (res.detailOptions) {
          this.detailOptions = res.detailOptions;
        } else {
          this.defaultOption(res.tags);
        }
        return true;
      } catch (error) {
        console.error('Failed to load product data:', error);
        this.$router.push({ name: 'website.products' });
        return false;
      }
      // this.loading = false;
    },
    async submitDelete() {
      try {
        productApi.remove(this.idItem);
        this.$router.push({ name: 'website.products' });
      } catch (error) {
        console.log(error);
      }
    },
    onCancel() {
      this.$v.$reset();
      this.attributes = Object.assign({}, this.defaultForm);
      this.$forceUpdate();
      this.$router.push({ name: 'website.products' });
    },
    extractExternalImages(html) {
      if (!html) return [];
      const approvedDomains = ['https://admin.skywarex.com/', 'https://cdn.skyfastimg.com/'];
      const imgRegex = /<img[^>]+src=["']([^"']+)["']/g;
      const externalImages = [];
      let match;

      while ((match = imgRegex.exec(html)) !== null) {
        const src = match[1];
        const isExternal = !approvedDomains.some(domain => src.startsWith(domain));
        if (isExternal && !externalImages.includes(src) && src.startsWith('http')) {
          externalImages.push(src);
        }
      }
      return externalImages;
    },
    async processExternalImages(html) {
      if (!html) return html;
      const externalImages = this.extractExternalImages(html);
      if (!externalImages.length) return html;

      let processedHtml = html;
      const isDev = process.env.NODE_ENV === 'development';

      for (const imageUrl of externalImages) {
        try {
          const { data } = await productApi.uploadExternalImage(imageUrl);
          const proxiedPath = data?.path || data;
          const pathWithoutLeadingSlash = proxiedPath.replace(/^\//, '');

          let newImageUrl;
          if (isDev) {
            newImageUrl = `https://cdn.skyfastimg.com/${pathWithoutLeadingSlash}`;
          } else {
            newImageUrl = `/uploads/${pathWithoutLeadingSlash}`;
          }

          processedHtml = processedHtml.replace(
            new RegExp(`src=["']${imageUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}["']`, 'g'),
            `src="${newImageUrl}"`,
          );
        } catch (error) {
          console.log('🚀 ~ processExternalImages ~ error:', error);
        }
      }
      return processedHtml;
    },
    async processImagesArray(images) {
      if (!Array.isArray(images) || !images.length) return images;
      const approvedDomains = ['https://admin.skywarex.com/', 'https://cdn.skyfastimg.com/'];
      const isDev = process.env.NODE_ENV === 'development';

      const processedImages = await Promise.all(
        images.map(async img => {
          if (!img || !img.src || !img.src.startsWith('http')) return img;

          const isExternal = !approvedDomains.some(domain => img.src.startsWith(domain));
          if (!isExternal) return img;

          try {
            const { data } = await productApi.syncImageFromUrl(img.src);
            const proxiedPath = data?.path || data;
            const pathWithoutLeadingSlash = proxiedPath.replace(/^\//, '');

            let newImageUrl;
            if (isDev) {
              newImageUrl = `https://cdn.skyfastimg.com/${pathWithoutLeadingSlash}`;
            } else {
              newImageUrl = `/${pathWithoutLeadingSlash}`;
            }

            return { ...img, src: newImageUrl };
          } catch (error) {
            console.log('🚀 ~ processImagesArray ~ error:', error);
            return img;
          }
        }),
      );

      return processedImages;
    },
    async onSubmit() {
      this.$v.$touch();
      utilities.scrollToTop();
      if (!this.$v.$invalid) {
        try {
          this.isLoading = true;
          let currentData = { ...this.attributes };
          let checkMissingPrice = false;
          let convertData = {
            options: this.options,
            ...this.attributes,
            variantDefault: this.variantDefault,
            collections:
              this.attributes.collections && this.attributes.collections.length > 0
                ? this.attributes.collections.map(it => {
                    return { _id: it };
                  })
                : null,
            detailOptions: this.detailOptions,
          };

          if (this.isVariantDefault) {
            convertData.variants =
              this.listVariants && this.listVariants.length > 0
                ? this.listVariants
                    .filter(item => {
                      return item.active === true;
                    })
                    .map(item => {
                      return {
                        ...item,
                        baseCost: Number(item?.baseCost?.toFixed(2) || 0),
                        inventoryPolicy: item.inventoryPolicy || 'continue',
                        shippingInfos: item.shippingCode
                          ? Object.keys(item.shippingCode).map(k => item.shippingCode[k])
                          : [],
                      };
                    })
                : this.attributes.variants;
          } else {
            convertData.variants = this.attributes.variants.map(item => {
              return {
                ...item,
                inventoryPolicy: item.inventoryPolicy || 'continue',
                shippingInfos: item.shippingCode ? Object.keys(item.shippingCode).map(k => item.shippingCode[k]) : [],
              };
            });
          }
          if (convertData?.variants?.length) {
            checkMissingPrice = convertData.variants.some(item => !item.price);
          }
          if (checkMissingPrice) {
            this.$store.commit('setMessages', {
              messages: 'You have to set price for variants!',
              type: 'error',
            });
            this.isLoading = false;
          } else {
            const processedBodyHtml = await this.processExternalImages(this.attributes.bodyHtml);
            const processedImages = await this.processImagesArray(this.attributes.images);

            convertData.bodyHtml = processedBodyHtml;
            convertData.images = processedImages;
            convertData.customOptions = this.customOptions;
            const res = await productApi.update(this.idItem, convertData);
            console.log(this.customOptions, 'customOptionssssss');
            if (
              res &&
              res.data &&
              res.data.product &&
              res.data.product.metafieldsGlobalUrlRedirect &&
              res.data.product.metafieldsGlobalUrl !== res.data.product.handle
            ) {
              let redirect = {
                fullLink: `/products/${res.data.product.metafieldsGlobalUrl}`,
                shortLink: `/products/${res.data.product.handle}`,
              };
              let resCheck = await shortlinkApi.check(redirect);
              if (resCheck && resCheck.data && resCheck.data.existed) {
                redirect.replace = true;
              } else {
                redirect.replace = false;
              }
              await shortlinkApi.create(redirect);
            }
            this.getData();
          }
        } catch (error) {
          console.log('🚀 ~ file: Update.vue:900 ~ onSubmit ~ error:', error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    onSelectedOptions(name, values) {
      for (const value of values) {
        if (!this.attributes.tags.includes(value)) {
          this.attributes.tags.unshift(value);
        }
      }
      let optionIndex = this.detailOptions.findIndex(option => option.name == name);
      if (optionIndex != -1) {
        this.detailOptions[optionIndex].values = values;
      } else {
        this.detailOptions.push({ name, values });
      }
    },
    removeOption(name, value) {
      if (this.attributes.tags.includes(value)) {
        const index = this.attributes.tags.indexOf(value);
        if (index >= 0) this.attributes.tags.splice(index, 1);
      }

      this.detailOptions.map(option => {
        if (option.name == name) {
          const index = option.values.indexOf(value);
          if (index >= 0) option.values.splice(index, 1);
        }
        return option;
      });
    },
    defaultOption(tags) {
      for (const tag of tags) {
        // Duyệt qua tags
        const template = this.getOptionTemplates?.find(template => template?.values?.includes(tag)); // Nếu có template nào matching thì xử lý
        if (!template) continue;
        let optionIndex = this.detailOptions?.findIndex(option => option && option?.name == template?.name); // Lấy ra option matching
        if (optionIndex != -1) {
          // Nếu đã có thì thêm vào mảng sẵn có
          this.detailOptions[optionIndex]?.values?.push(tag);
        } else {
          // không thì tạo cái mới
          this.detailOptions.push({ name: template?.name, values: [tag] });
        }
      }
    },
    getShippingInfo(code, shippingInfos) {
      return (shippingInfos || []).find(item => (item.countryCode || '').toLowerCase() === code.toLowerCase());
    },
    calculateProfit(v) {
      const price = v[`price`] + 0;
      let latePrintVariant = v.latePrintVariant || null;
      const baseCost = latePrintVariant ? latePrintVariant.cost : 0;

      const currentShippingProfile = this.getShippingInfo(
        this.shipCode,
        latePrintVariant ? latePrintVariant.shippingInfos : null,
      );
      // console.log('currentShippingProfile --> ', currentShippingProfile, v.latePrintVariant.shippingInfos);
      // const baseShipAdditionalItem = currentShippingProfile ? currentShippingProfile.shipAdditionalItem : 0;
      const baseShipFirstItem = currentShippingProfile ? currentShippingProfile.shipfirstItem : 0;
      // const newShipAdditionalItem = v.shippingCode.US.shipAdditionalItem || 0;
      const newShipFirstItem = v.shippingCode[this.shipCode].shipfirstItem || 0;

      const pFee = this.payment ? (this.payment.paymentFee + 0) / 100 : 0.03; //default: 3%
      const processFee = this.payment ? (this.payment.processingFee + 0) / 100 : 0.04; //default: 4%
      const paymentFee = (price + 0 + newShipFirstItem) * pFee;
      const processingFee = (price + 0 - baseCost - paymentFee) * processFee;
      const handlingFee = paymentFee + processingFee;
      const adjustShippingFee = newShipFirstItem - baseShipFirstItem;
      const profit = price - baseCost + adjustShippingFee - handlingFee;
      console.log('newShipFirstItem, baseShipFirstItem -->', newShipFirstItem, baseShipFirstItem);
      console.log('%paymentFee, %processingFee -->', pFee, processFee);
      console.log('price -->', price);
      console.log('paymentFee, processingFee -->', paymentFee, processingFee);
      console.log('handlingFee -->', handlingFee);
      console.log('adjustShippingFee -->', adjustShippingFee);
      console.log('profit -->', profit.toFixed(2));
      return profit.toFixed(2);
    },
    async loadPayments() {
      this.isLoading = true;
      try {
        let paymentsData = await paymentService.list();
        this.paymentMethods = paymentsData.data.map((item, k) => {
          return {
            ...item,
            fee: (parseFloat(item.paymentFee) || 0) + parseFloat(item.processingFee),
          };
        });
        this.paymentMethods.sort((a, b) => b.fee - a.fee);
        if (this.paymentMethods.length > 0) {
          this.payment = this.paymentMethods[0];
        }
        this.isLoading = false;
      } catch (error) {
        this.errors = error;
        this.isLoading = false;
      }
    },
    onPixelChanged(pixels) {
      this.attributes.pixels = pixels;
    },
    async getPersonalize() {
      try {
        let res = await personalizesApi.getPresionalizeWithProduct(this.$route.params.id);

        if (res.data) {
          this.data = res.data;
          let parser = new DOMParser();
          let xmlDocProduct = res.data.productionSvg
            ? parser.parseFromString(res.data.productionSvg, 'text/xml')
            : null;
          if (xmlDocProduct && xmlDocProduct.querySelector('image')) {
            xmlDocProduct.querySelector('svg').setAttribute('width', '100%');
            xmlDocProduct.querySelector('svg').setAttribute('height', '100%');
            let attributes = xmlDocProduct.querySelector('image').attributes;
            document.querySelector('.personalize-production').style.width = parseFloat(attributes.width.value) + `px`;
            document.querySelector('.personalize-production').innerHTML = xmlDocProduct.querySelector('svg').outerHTML;
            this.hasCustom = true;
            this.personalizedId = res.data._id;
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    async onSyncImages() {
      this.isLoading = true;
      const descriptionDiv = document.createElement('div');
      descriptionDiv.id = 'description-div';
      descriptionDiv.styles = 'display: none;';
      descriptionDiv.innerHTML = this.attributes.bodyHtml;
      for (const img of descriptionDiv.querySelectorAll('img')) {
        try {
          let url = img?.src || '';
          if (img?.srcset) {
            const urlSrcSet = img.srcset
              ?.split(',')?.[0]
              .trim()
              .replace(/\s\d+w$/, '');
            url = urlSrcSet;
          }
          const CDN_URLS = [
            'https://cdn.cdnshift.com',
            'https://cdn.cachebolt.com',
            'https://cdn.cdnstash.com',
            'https://cdn.cdnrails.com',
            'https://cdn.cacheimg.com',
            'https://cdn.skyfastimg.com',
          ];
          if (CDN_URLS.some(item => url.includes(item))) {
            // Tìm CDN URL phù hợp và thay thế bằng /uploads/
            const matchedCDN = CDN_URLS.find(cdnUrl => url.includes(cdnUrl));
            if (matchedCDN) {
              const newUrl = url.replace(matchedCDN, '/uploads');
              if (img?.src) img.setAttribute('src', newUrl);
              if (img?.srcset) {
                const srcSet = img.srcset.replaceAll(url, newUrl);
                img.setAttribute('srcset', srcSet);
              }
            }
            continue;
          }
          const { data } = await uploadService.getByProxy({ url });
          if (img?.src) img.setAttribute('src', `/uploads${data}`);
          if (img?.srcset) {
            const srcSet = img.srcset.replaceAll(url, `/uploads${data}`);
            img.setAttribute('srcset', srcSet);
          }
        } catch (error) {
          console.log('🚀 ~ file: index.vue:392 ~ onSyncImages ~ error:', error);
          img.remove();
        }
      }
      this.attributes.bodyHtml = descriptionDiv.innerHTML;
      descriptionDiv.remove();
      this.isLoading = false;
    },
    async getStoreStaffs() {
      try {
        let res = await authService.getStoreStaffs();
        const listStoreStaffs = res?.data || [];
        let indexOwner = listStoreStaffs?.findIndex(item => item.isStoreOwner === true);
        this.accountOwner = listStoreStaffs?.[indexOwner];
      } catch (error) {
        console.log(error);
      }
    },
    onUpdateBodyHtmlDescription(html) {
      this.attributes.bodyHtml = processFinalCatalogHtml(html);
    },
    onUpdateBodyHtmlOrderDescription(html) {
      this.attributes.orderDescription = processFinalCatalogHtml(html);
    },
    onUpdateBodyHtmlHurryBox(html) {
      this.attributes.shortDescription = processFinalCatalogHtml(html);
    },
    onUpdateBodyHtmlOrderPolicy(html) {
      this.attributes.orderPolicy = processFinalCatalogHtml(html);
    },
    handleShowFullPreview() {
      const regex = /prl-[a-z0-9]{6}/g;
      const replaceIds = html => {
        if (!html) return '';
        const uniqueId = Math.random()
          .toString(36)
          .slice(2, 8);
        return html.replace(regex, uniqueId);
      };
      const replaceHtmlSection = html => {
        if (!html) return '';
        const sections = html.split('</section>').map(section => {
          return replaceIds(section);
        });
        return sections.join('</section>');
      };
      this.fullPreview = {
        open: true,
        descriptionHtml: replaceHtmlSection(this.attributes.bodyHtml),
        orderPolicyHtml: replaceHtmlSection(this.attributes.orderPolicy),
        hurryBoxHtml: replaceHtmlSection(this.attributes.shortDescription),
        title: this.attributes.title,
        image: this.attributes.images[0],
      };
    },
    handleCloseFullPreview() {
      this.fullPreview = {
        open: false,
        descriptionHtml: '',
        orderPolicyHtml: '',
        hurryBoxHtml: '',
        title: '',
        image: '',
      };
    },
  },
  watch: {
    $route: function() {
      if (this.$route.name === 'website.products.update') {
        this.getData();
      }
    },
    attributes: {
      handler: function(val, oldVal) {
        this.showHeader = !utilities.comparisonTwoObject(this.defaultForm, this.attributes);
        // if (this.showHeader) {
        //   this.$v.$reset();
        // }
      },
      deep: true,
    },
    'attributes.tags': function(val, oldVal) {
      this.defaultOption(val);
    },
  },
  computed: {
    isDropship() {
      return this.pagePreference && this.pagePreference.businessType === 'dropship';
    },
    ...mapState({
      pagePreference: state => state.pagePreference.preference,
    }),
    ...mapGetters(['user', 'getOptionTemplates', 'stores']),
    storeURL() {
      return 'https://' + this.$store.state.auth.accountInfo.rDomain;
    },
    hasUpdateSection() {
      if (!this.user) return false;
      const isAccountOwner = this.accountOwner && this.accountOwner.id === this.user.id;
      const dropnoxeUser = JSON.parse(localStorage.getItem('dropnoxe-user') || '{}');
      const ignoreDropnoxeEmail = !!(dropnoxeUser?.email === 'homepage@dropnoxe.com');

      return ignoreDropnoxeEmail || isAccountOwner;
    },
  },
  validations: {
    attributes: {
      title: {
        required,
        minLength: minLength(0),
        maxLength: maxLength(255),
      },
      handle: {
        required,
        minLength: minLength(0),
        maxLength: maxLength(255),
      },
    },
  },
};
</script>
<style lang="scss">
.menu-sticky {
  position: sticky;
  top: 100px;
  left: 0;
  z-index: 100;
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  ul li {
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  ul li:hover {
    background-color: #f0f0f0;
  }

  ul li a {
    text-decoration: none;
    color: inherit;
    display: block;
  }

  ul li a:focus {
    outline: none;
    background-color: #e0e0e0;
  }
}
.product-page--create {
  .description-readonly img {
    max-width: 100% !important;
  }

  .btn-link {
    color: var(--v-primary-base);
    &:hover {
      text-decoration: none;
    }
  }
  .v-expansion-panel:before {
    box-shadow: none;
  }
  .v-expansion-panel-header__icon {
    position: absolute;
    right: 16px;
    top: 16px;
  }
}
.change-all-il {
  font-weight: normal;
  font-size: 12px;
  cursor: pointer;
}

.change-all-dialog {
  position: absolute;
  z-index: 10000000000000;
  width: 200px;
  border: 1px solid #ddd;
}
</style>
<style lang="scss" scoped>
.grid {
  display: grid !important;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.gap-4 {
  gap: 16px;
}

.action-buttons-sticky {
  position: fixed;
  bottom: 0;
  right: 256px;
  left: 256px; /* sidebar width */
  max-width: calc(100vw - 256px - 256px);
  padding: 16px 24px;
  background: white;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1264px) {
    left: 0;
    right: 0;
    max-width: 100vw;
  }
}

#description-edit-product .v-expansion-panel {
  background-color: transparent !important;
  &::before {
    box-shadow: none !important;
  }

  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
  ::v-deep .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: unset !important;
  }
}

.link-preview {
  background-color: color-mix(in srgb, var(--v-primary-base) 10%, white);
  border-radius: 8px;
  padding: 12px;
}

.link-preview__body {
  display: flex;
  margin-top: 8px;
  background-color: color-mix(in srgb, var(--v-primary-base) 5%, white);
  border-radius: 8px;
  padding: 12px;
  .link-preview__title {
    font-weight: bold;
    font-size: 16px;
  }
  .link-preview__description {
    color: #0009;
  }
}

.link-preview--compact .link-preview__body {
  flex-direction: row;
  gap: 10px;
}

.link-preview--compact .link-preview__content {
  flex: 1;
  min-width: 0;
}

.link-preview--compact .link-preview__image {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 4px;
}

.link-preview--large .link-preview__body {
  flex-direction: column;
}

.link-preview--large .link-preview__image {
  width: 100%;
  max-height: 300px;
  margin-top: 8px;
  object-fit: cover;
  border-radius: 4px;
}
</style>
